if (!customElements.get('bundle-buy-box')) {
  customElements.define(
    'bundle-buy-box',
    class BundleBuyBox extends HTMLElement {
      constructor() {
        super();
        this.variantId = this.dataset.variantId;
        this.submitButton = this.querySelector('[data-add-to-cart]');
        this.errorEl = this.querySelector('.bundle-buy-box__error');
        this.spinner = this.querySelector('.loading-overlay__spinner');

        this.querySelectorAll('.bundle-tier__radio').forEach((radio) => {
          radio.addEventListener('change', () => this.onTierChange(radio));
        });

        this.submitButton?.addEventListener('click', this.onSubmit.bind(this));

        this.countdownEl = this.querySelector('[data-countdown-to-midnight]');
        if (this.countdownEl) {
          this.updateCountdown();
          setInterval(() => this.updateCountdown(), 1000);
        }

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.setupStickyBar());
        } else {
          this.setupStickyBar();
        }
      }

      setupStickyBar() {
        this.stickyBar = document.querySelector('[data-sticky-buy-bar]');
        if (!this.stickyBar || !this.submitButton) return;

        const stickyButton = this.stickyBar.querySelector('[data-sticky-add-to-cart]');
        stickyButton?.addEventListener('click', () => this.onSubmit());

        const updateVisibility = () => {
          const rect = this.submitButton.getBoundingClientRect();
          const isInView = rect.top < window.innerHeight && rect.bottom > 0;
          this.stickyBar.hidden = isInView;
        };

        updateVisibility();
        window.addEventListener('scroll', updateVisibility, { passive: true });
        window.addEventListener('resize', updateVisibility);
      }

      updateCountdown() {
        const now = new Date();
        const midnight = new Date(now);
        midnight.setHours(24, 0, 0, 0);
        const diff = Math.max(0, midnight - now);
        const pad = (n) => String(n).padStart(2, '0');
        const hours = Math.floor(diff / 3600000);
        const minutes = Math.floor((diff % 3600000) / 60000);
        const seconds = Math.floor((diff % 60000) / 1000);
        this.countdownEl.textContent = `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
      }

      onTierChange(radio) {
        this.querySelectorAll('.bundle-tier').forEach((label) => {
          label.classList.remove('bundle-tier--selected');
        });
        radio.closest('.bundle-tier')?.classList.add('bundle-tier--selected');
      }

      get selectedQuantity() {
        const checked = this.querySelector('.bundle-tier__radio:checked');
        return checked ? parseInt(checked.value, 10) : 1;
      }

      get addonItems() {
        return Array.from(this.querySelectorAll('.bundle-addon__checkbox'))
          .filter((input) => input.checked && input.dataset.addonVariantId)
          .map((input) => ({ id: parseInt(input.dataset.addonVariantId, 10), quantity: 1 }));
      }

      setLoading(isLoading) {
        if (!this.submitButton) return;
        this.submitButton.toggleAttribute('disabled', isLoading);
        this.spinner?.classList.toggle('hidden', !isLoading);
      }

      async onSubmit() {
        if (!this.variantId) return;

        this.setLoading(true);
        if (this.errorEl) this.errorEl.hidden = true;

        const items = [{ id: parseInt(this.variantId, 10), quantity: this.selectedQuantity }, ...this.addonItems];

        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items }),
          });

          const data = await response.json();

          if (!response.ok) {
            throw new Error(data.description || data.message || 'Något gick fel, försök igen.');
          }

          window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
        } catch (error) {
          this.setLoading(false);
          if (this.errorEl) {
            this.errorEl.textContent = error.message;
            this.errorEl.hidden = false;
          }
        }
      }
    }
  );
}
